import { useCallback } from 'react';
import { useApolloClient, useMutation } from '@apollo/client/react';
import { DeleteMyAccountDocument, MeDocument, type MeQuery } from 'graphql/generated/graphql';

const useDeleteMyAccount = () => {
  const client = useApolloClient();
  const [deleteMyAccountMutation] = useMutation(DeleteMyAccountDocument);

  const deleteMyAccount = useCallback(async () => {
    await deleteMyAccountMutation();

    client.writeQuery<MeQuery>({ query: MeDocument, data: { me: null } });
    client.resetStore().catch(() => {});
  }, [client, deleteMyAccountMutation]);

  return deleteMyAccount;
};

export default useDeleteMyAccount;
